(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/hooks/assets/javascripts/use-memoized-selector.js') >= 0) return;  svs.modules.push('/components/lb-utils/hooks/assets/javascripts/use-memoized-selector.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useRef = _React.useRef,
  useState = _React.useState,
  useEffect = _React.useEffect;
const useMemoizedSelector = function (makeSelector) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  const _useState = useState(() => makeSelector(...args)),
    _useState2 = _slicedToArray(_useState, 2),
    selector = _useState2[0],
    setSelector = _useState2[1];
  const previousArgs = useRef(args);
  useEffect(() => {
    const isSame = args.every((arg, index) => arg === previousArgs.current[index]);
    if (!isSame || args.length !== previousArgs.current.length) {
      previousArgs.current = args;
      setSelector(() => makeSelector(...args));
    }
  }, [makeSelector, args]);
  useEffect(() => {
    setSelector(() => makeSelector(...previousArgs.current));
  }, [makeSelector]);
  return selector;
};
setGlobal('svs.components.lbUtils.hooks.useMemoizedSelector', useMemoizedSelector);

 })(window);